import * as React from "react";
import { cn } from "../../lib/utils";
import { Button } from "./button";
import { RxCross2 } from "react-icons/rx";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  tags: string[];
  onTagsChange: (tags: string[]) => void;
}

const TagsInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ tags, onTagsChange, className, type, error, ...props }, ref) => {
    // input text.
    const [text, setText] = React.useState<string>("");

    const handleRemoveTag = (index: number) => {
      onTagsChange(tags.filter((_, i) => i !== index));
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (text.trim() === "") {
          return;
        }
        onTagsChange([...tags, text.trim()]);
        setText("");
      }
    };

    const onButtonClick = () => {
      if (text.trim() === "") {
        return;
      }
      onTagsChange([...tags, text.trim()]);
      setText("");
    };

    return (
      <div className="relative w-full">
        {tags.map((tag, index) => (
          <div
            key={index}
            className="inline-block py-auto bg-borderColor my-1 text-primary-background rounded  py-1 text-xs mr-2"
          >
            <div className="flex items-center justify-center px-1 ps-2">
              {tag}
              <button
                onClick={() => {
                  handleRemoveTag(index);
                }}
                className="ml-3"
              >
                <RxCross2 size={18} className="hover:text-primary" />
              </button>
            </div>
          </div>
        ))}

        <div className="flex">
          <input
            type={type}
            value={text}
            onKeyDown={handleKeyDown}
            onChange={(e) => setText(e.target.value)}
            className={cn(
              "flex h-10 w-full rounded-md border border-input bg-transparent text-white placeholder px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none /focus-visible:ring-2 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 rounded-r-none border-r-0",
              {
                "border-red-500 focus-visible:ring-red-500": error,
                "focus:border-red-500": error,
              },
              className
            )}
            ref={ref}
            {...props}
          />

          <Button
            disabled={text.trim() === ""}
            className={cn(
              "rounded-l-none px-8 border-1 border-l-0  bg-borderColor",
              {
                "bg-primary": text.trim() !== "",
              }
            )}
            onClick={onButtonClick}
          >
            Add Tag
          </Button>
        </div>
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      </div>
    );
  }
);
TagsInput.displayName = "TagsInput";

export { TagsInput };
